import { Component, inject } from '@angular/core';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { ContainerComponent } from '../../../shared/components/container/container.component';
import { GlobalModalService } from '../../../shared/services/global-modal.service';

@Component({
  selector: '[about-the-survey]',
  imports: [ContainerComponent, NgbAccordionModule],
  templateUrl: './about-the-survey.component.html',
  styleUrl: './about-the-survey.component.scss',
})
export class AboutTheSurveyComponent {
  private modalService = inject(GlobalModalService);

  navigateTo(url: string, e: Event) {
    e.preventDefault();
    this.modalService.openModal('interstitial', url);
  }
}

